/**
 * variant-first-available.js
 *
 * Clicks the first enabled radio when the checked option is unavailable
 * (class "disabled" or disabled attribute) — e.g. Oval + 120cm when 120cm is Round-only.
 *
 * 1) Add after product-info.js in main-product.liquid:
 *    <script src="{{ 'variant-first-available.js' | asset_url }}" defer></script>
 *
 * 2) REQUIRED — patch product-info.js handleUpdateProductInfo (see bottom of this file).
 *    Without that patch, getSelectedVariant(html) runs before the live DOM is fixed and
 *    returns null, so setUnavailable() runs and the picker never recovers.
 */
(function () {
  function isInvalidRadio(input) {
    if (!input) return true;
    return (
      input.disabled === true ||
      (input.classList && input.classList.contains('disabled'))
    );
  }

  /** Fieldsets, or Dawn-style .product-form__input wrappers, or bare .var_swatch rows */
  function getOptionGroups(root) {
    if (!root) return [];
    var fs = root.querySelectorAll('fieldset');
    if (fs.length) {
      return Array.prototype.slice.call(fs);
    }
    var inputs = root.querySelectorAll('.product-form__input');
    if (inputs.length) {
      return Array.prototype.slice.call(inputs);
    }
    var sw = root.querySelectorAll('.var_swatch');
    if (sw.length) {
      return Array.prototype.slice.call(sw);
    }
    return [root];
  }

  function fixOptionGroup(group) {
    var checked = group.querySelector('input[type="radio"]:checked');
    if (!checked || !isInvalidRadio(checked)) {
      return false;
    }
    var radios = group.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var input = radios[i];
      if (!isInvalidRadio(input)) {
        input.click();
        return true;
      }
    }
    return false;
  }

  function fixVariantSelects(root) {
    if (!root) return false;
    var groups = getOptionGroups(root);
    var any = false;
    for (var j = 0; j < groups.length; j++) {
      if (fixOptionGroup(groups[j])) {
        any = true;
      }
    }
    return any;
  }

  /** Sync entry: call from product-info after updateOptionValues */
  function fixVariantSelectsSync(root) {
    return fixVariantSelects(root);
  }

  window.variantFirstAvailable = fixVariantSelectsSync;

  function observeEl(el) {
    if (!el || el.getAttribute('data-vfa-observed')) return;
    el.setAttribute('data-vfa-observed', 'true');

    var scheduled = false;
    function run() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        fixVariantSelects(el);
      });
    }

    var obs = new MutationObserver(run);
    obs.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });

    document.addEventListener(
      'change',
      function (e) {
        if (!el.contains(e.target)) return;
        if (e.target.type !== 'radio') return;
        run();
      },
      true
    );

    run();
  }

  function scan() {
    document.querySelectorAll('variant-selects').forEach(observeEl);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(function () {
        document.querySelectorAll('variant-selects').forEach(function (el) {
          fixVariantSelects(el);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();

/*
 * === PATCH product-info.js — handleUpdateProductInfo ===
 *
 * (A) Remove the DUPLICATE call to this.updateOptionValues(html) later in the same callback.
 *
 * (B) Replace the start of the returned function with this pattern:
 *
 *   handleUpdateProductInfo(productUrl) {
 *     return (html) => {
 *       this.updateOptionValues(html);
 *
 *       if (typeof window.variantFirstAvailable === 'function') {
 *         window.variantFirstAvailable(this.querySelector('variant-selects'));
 *       }
 *
 *       const variant = this.getSelectedVariant(this);
 *       if (!variant) {
 *         this.setUnavailable();
 *         return;
 *       }
 *       const variantValues = variant.options;
 *       ... rest of your code (slick, etc.) ...
 *
 *       REMOVE the second this.updateOptionValues(html) before pickupAvailability.
 *
 * Key: use getSelectedVariant(this) with LIVE <product-info>, not getSelectedVariant(html).
 * After variantFirstAvailable clicks a valid radio, [data-selected-variant] updates for this.
 */
